<template>
    <img :src="'../storage/' + $page.props.apps.logo" class="w-auto size-16" />
</template>
<script setup>
const props = defineProps({
    judul: {
        type: String,
    },
});
</script>
